// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"CN-z","upvoteIcon":"DN-z","downvoteIcon":"EN-z","feedbackIcon":"FN-z"};